import { Injectable, inject } from "@angular/core";
import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandManager, ICommand } from "~app/common/services/cqs/commandManager";
import { InvalidateKontraktCommand } from "../commands/cqs/InvalidateKontraktCommand";
import { KontraktMediatorService } from "./kontrakt-mediator.service";
import { VirkeskopValidationService } from "./validation/virkeskop-validation.service";

@Injectable()
export class KontraktCommandService {
    private readonly validationService = inject(VirkeskopValidationService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);
    private readonly commandManager = inject(CommandManager);

    update(command: BasicCommand<unknown>) {
        this.commandManager.updateCommand(command);
        this.validationService.validateOnChange(this.commandManager);
        this.updateMetaCommand();
    }

    remove(command: BasicCommand<unknown>) {
        this.commandManager.remove(command);
    }

    /**
     * @deprecated använd update
     */
    addOrUpdate<T extends ICommand>(command: T, filter: (command: T) => boolean) {
        this.commandManager.addOrUpdate(command, filter);
        this.validationService.validateOnChange(this.commandManager);

        console.warn("otillåten anvädning av addOrUpdate, använd update");
        this.updateMetaCommand();
    }

    private updateMetaCommand() {
        const kontrakt = this.kontraktMediatorService.kontrakt;
        this.commandManager.updateMetaCommand(new InvalidateKontraktCommand(kontrakt.guid, kontrakt.id, kontrakt.rowVersion));
    }
}
